import React, { Fragment } from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import {
  Box,
  Divider,
  TextField,
  FormLabel,
  Switch,
  Typography,
  useMediaQuery,
} from '@material-ui/core'
import { Alert } from '@material-ui/lab'

import useStyles from './styles'
import theme from 'theme'

const PrivacyPortalCustomization = () => {
  const classes = useStyles()
  const { control, watch, errors, register } = useFormContext()
  const privacyPortalEnabled = watch('privacyPortalEnabled')

  const mdUp = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  })

  return (
    <Fragment>
      <Box
        display="flex"
        flexDirection="column"
        gridGap={theme.spacing(2)}
        width="100%"
      >
        <FormLabel className={classes.formLabel} color="primary">
          Canal de Atendimento ao Titular de Dados
        </FormLabel>
        <Box display="flex" alignItems="center" gridGap={theme.spacing(1)}>
          <Controller
            control={control}
            name="privacyPortalEnabled"
            onChange={([, checked]) => checked}
            as={<Switch color="primary" />}
          />
          <Typography className={classes.switchLabel}>
            Exibir link para o canal de atendimento ao titular de dados
          </Typography>
        </Box>
        {privacyPortalEnabled && (
          <TextField
            name="privacyPortalUrl"
            inputRef={register()}
            error={!!errors?.privacyPortalUrl}
            helperText={errors?.privacyPortalUrl?.message}
            label="Link do Canal de atendimento ao titular de dados"
            placeholder="https://exemplo.com/canal-de-atendimento"
            type="url"
            color="primary"
            variant="outlined"
            fullWidth
            InputLabelProps={{ shrink: true }}
          />
        )}
        <Alert severity="info" className={classes.alert}>
          O Canal de Atendimento ao Titular de Dados permite que seus usuários
          tenham acesso completo às configurações de privacidade e cookies do
          seu site, oferecendo maior transparência e controle sobre seus dados
          pessoais.
        </Alert>
      </Box>
      {mdUp && <Divider orientation="vertical" variant="middle" />}
    </Fragment>
  )
}

export default PrivacyPortalCustomization
